import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    styled,
    Backdrop,
    CircularProgress,
    Box
} from '@mui/material';

import theme from '../../../theme';
import { useGet } from '../../../lib/api/hooks';
import { DecisionReasonModel } from '../../../lib/models/DecisionReasonModel';
import { CaseProcedureListingProps } from './InitialReviewProcedureListing';
import AppealProcedureItem from './AppealProcedureItem';
import { CaseStages } from '../../../lib/constants/misc';
import { useScreenSmallerThan } from '../../../lib/hooks/breakpoint-hooks';
import { backdropStyle } from '../../../style';

function AppealProcedureListing({
    procedureList,
    crmId,
    crmClientName,
    caseStage,
    handleReasonDenialChange,
    setAnyChangeMade
}: CaseProcedureListingProps) {
    const { data, loading } = useGet<DecisionReasonModel[]>(
        `decisionreason/getlist?crmId=${crmId}`
    );
    const isSmallerThanSmall = useScreenSmallerThan('sm');
    const isSmallerThanLarge = useScreenSmallerThan(
        caseStage === CaseStages.FirstLevelAppeal ? 1090 : 1140
    );

    const showReconsiderationsDecision =
        caseStage === CaseStages.FirstLevelAppeal || caseStage === CaseStages.SecondLevelAppeal
            ? true
            : false;
    const showSecondaryDecisionReason = caseStage === CaseStages.ClaimMedicalReview ? true : false;
    const showFirstDecision = caseStage === CaseStages.SecondLevelAppeal ? true : false;
    const lastDecisionName =
        caseStage === CaseStages.SecondLevelAppeal ? 'Tertiary Decision' : 'Secondary Decision';
    const lastDecisionReason =
        caseStage === CaseStages.SecondLevelAppeal
            ? 'Tertiary Decision Reason'
            : 'Secondary Decision Reason';

    const TableHeaderCell = styled(TableCell)({
        color: theme.palette.cardSubtitle.main,
        fontSize: 13,
        borderBottom: 'none'
    });

    return (
        <>
            {!loading ? (
                <>
                    {data != null ? (
                        !isSmallerThanSmall && !isSmallerThanLarge ? (
                            <>
                                <TableContainer sx={{ padding: '1.25rem', paddingTop: '0.625rem' }}>
                                    <Table
                                        sx={{
                                            background: 'white',
                                            borderRadius: !isSmallerThanSmall ? '0.625rem' : '0'
                                        }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableHeaderCell>Requested Code</TableHeaderCell>
                                                <TableHeaderCell>Description</TableHeaderCell>
                                                <TableHeaderCell>Units</TableHeaderCell>
                                                <TableHeaderCell>
                                                    Nurse Recommendation
                                                </TableHeaderCell>
                                                <TableHeaderCell>
                                                    Initial Physician Decision
                                                </TableHeaderCell>
                                                <TableHeaderCell>
                                                    Initial Denial Reason
                                                </TableHeaderCell>
                                                {showReconsiderationsDecision ? (
                                                    <TableHeaderCell>
                                                        Reconsiderations Decision
                                                    </TableHeaderCell>
                                                ) : null}
                                                {showFirstDecision ? (
                                                    <TableHeaderCell>
                                                        First Level Decision
                                                    </TableHeaderCell>
                                                ) : null}
                                                <TableHeaderCell>
                                                    {lastDecisionName}
                                                </TableHeaderCell>
                                                {!showReconsiderationsDecision &&
                                                showSecondaryDecisionReason ? (
                                                    <TableHeaderCell>
                                                        {lastDecisionReason}
                                                    </TableHeaderCell>
                                                ) : null}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {procedureList != null && procedureList.length > 0
                                                ? procedureList.map((item, index) => (
                                                      <AppealProcedureItem
                                                          key={index}
                                                          item={item}
                                                          crmClientName={crmClientName}
                                                          reasons={data}
                                                          caseStage={caseStage}
                                                          handleReasonDenialChange={
                                                              handleReasonDenialChange
                                                          }
                                                          setAnyChangeMade={setAnyChangeMade}
                                                      />
                                                  ))
                                                : null}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {/*  to do add new row */}
                            </>
                        ) : (
                            <Box
                                sx={{
                                    background: 'white',
                                    borderRadius: !isSmallerThanSmall ? '0.625rem' : '0',
                                    margin: isSmallerThanSmall ? '0' : '0.875rem',
                                    padding: '0.625rem'
                                }}>
                                {procedureList != null && procedureList.length > 0
                                    ? procedureList.map((item, index) => (
                                          <AppealProcedureItem
                                              key={index}
                                              item={item}
                                              reasons={data}
                                              crmClientName={crmClientName}
                                              caseStage={caseStage}
                                              handleReasonDenialChange={handleReasonDenialChange}
                                              setAnyChangeMade={setAnyChangeMade}
                                          />
                                      ))
                                    : null}
                            </Box>
                        )
                    ) : null}
                </>
            ) : (
                <>
                    <Backdrop sx={backdropStyle} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </>
            )}
        </>
    );
}

export default AppealProcedureListing;
